import { useSelector } from 'react-redux'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from './store'
import { useDispatchActions, setStoreState } from './utils'
import { storageUtil } from '@/utils'

const { getLocalStorage, setLocalStorage } = storageUtil
export interface Cart {
  cartId: string
  amount: number
  quantity: number
  [key: string]: any
}

const initialState: Cart = {
  cartId: '',
  amount: 0,
  quantity: 0,
  productCount: 0,
}

export const slice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setCart: (state, action: PayloadAction<Cart>) => {
      const payload = action.payload
      setStoreState(state, payload, initialState)
      setLocalStorage('cart', payload)
    },
  },
})

export const { setCart } = slice.actions

export const reducer = slice.reducer

export default function useCartStore() {
  const state = useSelector((state: RootState) => state.cart)
  const storageState = getLocalStorage('cart', true) || {}
  const actionPool = useDispatchActions(slice.actions)

  return {
    cart: { ...state, ...storageState },
    ...actionPool,
  }
}
